import React, { forwardRef, useCallback, useEffect, useMemo, useState } from 'react';
import { withStyles } from '@material-ui/styles';
import cn from 'classnames';
import styles from '../styles';
import { makeStyles } from '@material-ui/core';
import { useFormContext, useWatch } from 'react-hook-form';
import ImageModal from '../../../ImageCarousel/ImageModal';

const useStyles = makeStyles(styles);

const Image = ({ label, src, labelStyle, imageStyle, className }, ref) => {
  const [open, setOpen] = useState(false);

  const image = <img
    onClick={() => setOpen(true)}
    src={src}
    style={{
      width: '100%',
      display: 'flex',
      cursor: "pointer",
      ...(!!src ? imageStyle : {}),
    }}
    className={className}
  />;

  const classes = useStyles();
  return (
    <div className="col-start-start">
      <label
        className={classes.inputLabel}
      >
        {label}
      </label>
      <ImageModal image={src={src}} open={open} onClose={() => setOpen(false)} canEdit/>

      <div style={{ position: 'relative', width: '100%', minHeight: 100, marginTop: 10 }}>
        {!src && (
          <span
            className="row-center-center"
            style={{
              border: '1px solid gray',
              borderRadius: 10,
              position: 'absolute',
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              opacity: 0.5,
            }}
          >
            No image
          </span>
        )}

        {image}
      </div>
    </div>
  );
};

export default forwardRef(Image);
